import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { LoginResponse } from "../../data/interfaces";
import { SESSION } from "../../data/constants";

interface SessionState {
  restaurant?: LoginResponse;
  accessToken?: string;
}

const initialState: SessionState = {};

export const sessionSlice = createSlice({
  name: SESSION.NAME,
  initialState,
  reducers: {
    logout(state) {
      delete state.restaurant;
      delete state.accessToken;
    },
    setRestaurant(state, action) {
      state.restaurant = action.payload;
      if (action.payload.accessToken)
        state.accessToken = action.payload.accessToken;
    },
  },
});

export const sessionReducer = persistReducer(
  {
    key: SESSION.RTK_KEY,
    storage,
    whitelist: SESSION.WHITE_LIST,
  },
  sessionSlice.reducer
);

export const { logout, setRestaurant } = sessionSlice.actions;
